import "antd/dist/antd.css";
import "../styles/globals.scss";
import "../styles/scrollbar.scss";
import "../styles/SelectShare.scss";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import "react-widgets/styles.css";
import "react-awesome-slider/dist/styles.css";
import "keen-slider/keen-slider.min.css";
import "react-circular-progressbar/dist/styles.css";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import "yet-another-react-lightbox/styles.css";
import NextNprogress from "nextjs-progressbar";
import "react-nestable/dist/styles/index.css";

import { useEffect } from "react";
import Script from "next/script";
import SEO from "../next-seo.config";
import { DefaultSeo } from "next-seo";
import { useRouter } from "next/router";
import { AnimatePresence } from "framer-motion";
import { ToastContainer } from "react-toastify";
import toast, { Toaster } from "react-hot-toast";
import useNetworkError from "hooks/useNetworkError";
import * as gtag from "../lib/gtag";

function MyApp({ Component, pageProps }) {
  const { error, resetError } = useNetworkError();

  useEffect(() => {
    if (error && error.message) {
      toast.error(error.message);
      setTimeout(() => resetError(), 300);
    }
  }, [error, resetError]);

  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = (url) => {
      gtag.pageview(url);
    };
    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);

  return (
    <>
      <DefaultSeo {...SEO} />
      <Script src="https://code.jquery.com/jquery-3.6.0.min.js" strategy="beforeInteractive" />
      <Script src="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/js/bootstrap.bundle.min.js" strategy="beforeInteractive" />

      <Script src="https://cdn.jsdelivr.net/npm/summernote@0.9.0/dist/summernote-bs5.js" strategy="beforeInteractive" />
      {/* <Script src="https://cdn.jsdelivr.net/npm/summernote@0.8.18/dist/summernote.min.js" /> */}

      <Script src="https://cdn.jsdelivr.net/npm/fullcalendar@5.5.1/main.min.js" />

      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${gtag.GA_TRACKING_ID}`}
        strategy="afterInteractive"
      />

      <Script
        id="gtag-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${gtag.GA_TRACKING_ID}', {
              page_path: window.location.pathname,
            });
          `,
        }}
      />
      <NextNprogress
        color="#96DAFF"
        startPosition={0.3}
        stopDelayMs={200}
        height={4}
      />
      <AnimatePresence mode="wait">
        <Component {...pageProps} />
      </AnimatePresence>
      <ToastContainer />
      <Toaster
        containerStyle={{
          zIndex: 10000000011,
        }}
      />
      <div id="shared-modal" />
      <div id="shared-modal-tautan-link" />
      <Script
        src="https://cdn.jsdelivr.net/npm/@popperjs/core@2.11.8/dist/umd/popper.min.js"
        integrity="sha384-I7E8VVD/ismYTF4hNIPjVp/Zjvgyol6VFvRkX/vR+Vc4jQkC+hVqc2pM8ODewa9r"
        crossOrigin="anonymous"
      />
      <Script src="/js/app.js" />
      <Script src="https://cdn.jsdelivr.net/npm/promise-polyfill@8/dist/polyfill.min.js" />
      <Script
        id="MathJax-script"
        strategy="afterInteractive"
        src="https://cdnjs.cloudflare.com/ajax/libs/mathjax/3.2.2/es5/tex-mml-chtml.min.js"
      />
      <Script src="https://unpkg.com/mathlive" />
    </>
  );
}

export default MyApp;
